<template>
    <div>
      <gobuy-head :title="$t('MyCard')" />
      <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
      <div class="box" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <!-- 卡片类型切换 -->
          <div class="card-switch">
            <span :class="['switch-item', cardType === 'gold' ? 'active' : '']" @click="switchCard('gold')">
              Gold Card
            </span>
            <span class="divider">|</span>
            <span :class="['switch-item', cardType === 'gift' ? 'active' : '']" @click="switchCard('gift')">
              Gift Card
            </span>
          </div>
        <div v-if="myCardList && myCardList.length" style="padding-bottom:80px;" @scroll.passive="loadMore">
          <div class="box_list" v-for="(item,index) in myCardList" :key="index">
            <div class="box_list_header">
              <img :src="item.image" :class="item.status==1 ? 'filter' : ''"/>
              <div class="comlist_header_rt">
                <div class="header_rt_txt">{{item.create_time}}</div>
                <div class="header_rt_foot ">{{item.number}}</div>
                <div class="header_rt_foot ">{{item.code}}</div>
                <div class="recycle" v-if="item.status!=1" @click="goRecycle(item)">{{ $t("Recycle") }} >></div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty" v-else-if="myCardList && !myCardList.length">
          <empty-record></empty-record>
        </div>
      </div>
    </div>
</template>

<script>
import { Indicator,Toast,MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getMyCardList,getMyGoldCardList } from '../../../api/giftcard'
export default {
  name: 'MyCardList',
  data () {
    return {
      params: {
        page: 1,
        per_page: 10
      },
      loading: false,
      isMore: true,
      myCardList: [],
      cardType: 'gold'
    }
  },
  components: {
    EmptyRecord,
  },
  mounted () {
    const type = this.$route.query.type == 2 ? 'gold' : 'gift'
    this.switchCard(type)
  },
  methods: {
    switchCard(type) {
      if (this.cardType === type) return
      this.cardType = type
      //重置分页状态
      this.params.page = 1
      this.isMore = false
      this.loading = true
      this.myCardList = []
      this.getDataList(true)
    },
    loadMore () {
      if (this.loading || !this.isMore) return
      this.loading = true
      if(this.myCardList.length==0){
        this.params.page=1
      }else{
        this.params.page++
      }
      // this.params.page++
      this.getDataList()
    },
    getDataList(reset = false) {
      Indicator.open()
      const api = this.cardType === 'gold' ? getMyGoldCardList : getMyCardList
      api(this.params).then(res => {
        Indicator.close()
        const list = res.result.data || res.result
        if (list.length < this.params.per_page) {
          this.isMore = false
        }
        if (reset) {
          this.myCardList = list
        } else {
          this.myCardList = this.myCardList.concat(list)
        }
        this.loading = false
      }).catch(err => {
        Indicator.close()
        Toast(err.message)
        this.loading = false
      })
    },
    goRecycle(item){
      const msg = this.cardType == 'gold' ? "Gold Card Recycling?" : "Gift Card Recycling?";
      MessageBox({
        title: this.$t("MessageBox.Tips"),
        message: msg,
        confirmButtonText: this.$t("MessageBox.Confirm"),
        cancelButtonText: this.$t("MessageBox.Cancel"),
        showCancelButton: true,
      }).then((action) => {
        if (action == "confirm") {
          if(this.$IFR.is_iframe == 1){
            window.location.href = '/member/gift_save?is_iframe=1&number='+item.number+'&code='+item.code
          }else{
            this.$router.push({ name: "GiftSave", query: { number: item.number, code: item.code, type: this.cardType === 'gold' ? 2 : 1 } });
          }
        }
      })
    },
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t('succ'))
          console.log(e);
        }, (e) => {
          Toast(this.$t('err'))
          console.log(e);
        }
      );
    },
  }
}
</script>

<style scoped lang="scss">
  .card-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 15px;
  font-size: 14px;
  color: #999;

  .switch-item {
    cursor: pointer;
    padding: 0 8px;
  }

  .active {
    color: #EF4618;
    font-weight: bold;
    text-decoration: underline;
  }

  .divider {
    margin: 0 5px;
  }
}
.recycle{
  cursor: pointer;
  background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
  padding: 0px 10px;
  border-radius: 5px;
  color: #ffffff;
  float: right;
  font-size: 12px;
}
.filter{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.box {
  .box_list {
    position: relative;
    background: linear-gradient(180deg, #FFFAF8 0%, #FFD7C5 100%);
    width: 100%;
    padding: 10px 10px;
    border-bottom: 1px solid #DDA8A8;
    
    .box_list_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      img {
        height: 101px;
        object-fit: contain;
        margin-right: 6px;
      }

      .comlist_header_rt {
        margin-right: .4rem;
        line-height: 24px;
        text-align: right;
        .header_rt_tit {
          font-size: 14px;
        }

        .header_rt_txt {
          font-size: 14px;
          line-height: 24px;
        }
        .header_rt_foot{
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          img {
            width: 15px;
            height: 15px;
            margin-left: 4px;
          }
        }
        .header_rt_btn {
          background: #E2B72B;
          border-radius: 6px;
          font-size: 18px;
          color: #FFFFFF;
          height: 30px;
          line-height: 30px;
          width: 100px;
          text-align: center;
          position: absolute;
          right: 20px;
          margin-top: 5px;
        }
      }
    }

    .box_list_foot {
      margin-bottom: 10px;

      img {
        width: 15px;
        height: 15px;
        margin-left: 4px;
      }
    }
  }
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>
